import { OButton, OInput, OSelect } from '@src/shared';
import { preventFormKeys } from '@src/utils';

import { ProgressSpinner } from 'primereact/progressspinner';
import useRegistrationForm from './useRegistrationForm';

import './registrationForm.scss';

const RegistrationForm = () => {
  const {
    countries,
    formData,
    handleChange,
    handleSubmit,
    setSelectedCountry,
    formErrors,
    roomData,
    formatDate,
    formatDateWithGmt,
    isLoading,
    isValidating,
    isRegistrationEnabled,
  } = useRegistrationForm();

  const ssoUrl = process.env.REACT_APP_SSO_URL;

  if (isValidating || !isRegistrationEnabled) {
    return (
      <div className="registration-form-container">
        <ProgressSpinner />
      </div>
    );
  }

  return (
    <div className="registration-form-container">
      <div className="registration-form-card">
        <p className="registration-form-title">Webinar registration</p>
        <div className="registration-info-container">
          <div className="registration-info">
            <div className="registration-info-content">
              <span className="registration-info-label">Topic</span>
              <span className="registration-info-label">Time</span>
            </div>
            <div className="registration-info-content">
              <span className="registration-info-value">{roomData?.roomTitle}</span>
              <span className="registration-info-value">
                {roomData?.startTime ? formatDateWithGmt(roomData?.startTime) : 'N/A'}
              </span>
            </div>
          </div>
        </div>

        <form
          className="registration-form"
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit(e);
          }}
          onKeyDown={(e) => preventFormKeys(e, ['Enter'])}
        >
          <div className="registration-form-grid">
            <div className="registration-form-field">
              <label htmlFor="firstName" className="registration-form-label">
                Name *
              </label>
              <OInput
                id="firstName"
                type="text"
                name="firstName"
                value={formData.firstName}
                className="registration-input"
                onChange={handleChange}
                autoComplete="off"
              />
              {formErrors.firstName && <p className="invalid">{formErrors.firstName}</p>}
            </div>

            <div className="registration-form-field">
              <label htmlFor="firstName" className="registration-form-label">
                Email address *
              </label>
              <OInput
                id="email"
                type="email"
                name="email"
                className="registration-input"
                onChange={handleChange}
                autoComplete="off"
              />
              {formErrors.email && <p className="invalid">{formErrors.email}</p>}
            </div>
            <div className="registration-form-field">
              <label htmlFor="firstName" className="registration-form-label">
                Company
              </label>
              <OInput
                id="company"
                type="text"
                name="company"
                className="registration-input"
                value={formData.company}
                onChange={handleChange}
              />
            </div>
            <div className="registration-form-field">
              <label htmlFor="firstName" className="registration-form-label">
                Country
              </label>
              <OSelect
                items={[{ label: 'None', value: '' }, ...countries]}
                onChange={(value) => setSelectedCountry(value)}
                selectedValue={formData.countryCode}
                size={'full'}
              />
            </div>
            <div className="registration-form-field">
              <label htmlFor="firstName" className="registration-form-label">
                City
              </label>
              <OInput
                id="city"
                className="registration-input"
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="registration-form-footer">
            <p className="registration-terms">
              By registering, I agree to the{' '}
              <a href={`${ssoUrl}/legal/privacy-policy`} target="_blank" rel="noopener noreferrer">
                Privacy policy
              </a>{' '}
              and{' '}
              <a href={`${ssoUrl}/legal/terms-conditions`} target="_blank" rel="noopener noreferrer">
                Terms of service
              </a>
              .
            </p>
            <div className="registration-submit-container">
              {roomData?.roomSetting?.registrationRequired && roomData.roomSetting.registrationExpiryDate && (
                <p className="registration-warning">
                  Don't miss out - webinar registration closes on{' '}
                  {roomData?.roomSetting?.registrationExpiryDate
                    ? formatDate(roomData.roomSetting.registrationExpiryDate)
                    : ''}
                  !
                </p>
              )}
              <div>
                <OButton variant="alternative" size="x-medium" text="Register" type="submit" loading={isLoading} />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegistrationForm;
